import html from "./CountdownStep.html"
import "./CountdownStep.css"
import moment from 'moment-timezone';

var module = angular.module("ResearchKitApplicationModule");

module.directive("countdownStep",
	["ceUrl", function (ceUrl) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			}
		};
	}]
);

module.controller("countdownStepController", ["$scope", "$interval",
	function ($scope, $interval) {

		$scope.duration = $scope.stepManager.step.stepDuration;
		$scope.secondsRemaining = $scope.duration;
		$scope.countdownIndicatorPath = createCirclePath(61, 61, 60, 0, 359.99);
		var countdownInterval;

		$scope.beginCountdown = function () {
			$scope.countdownStart = moment();
			countdownInterval = $interval(function () {
				var durationMillis = moment().diff($scope.countdownStart);
				var remainingDuration = $scope.duration - (durationMillis / 1000);
				if ($scope.secondsRemaining <= 0) {
					$scope.stepManager.continue();
				}
				var degrees = (remainingDuration / $scope.duration) * 359.99;
				$scope.countdownIndicatorPath = createCirclePath(61, 61, 60, 0, degrees);
				$scope.secondsRemaining = Math.ceil(remainingDuration);
			}, 100);
		}

		$scope.$on('$destroy', function () {
			cancelCountdownInterval();
		});

		function cancelCountdownInterval() {
			if (countdownInterval) {
				$interval.cancel(countdownInterval);
			}
		}

		function calculateCirclePoint(centerX, centerY, radius, degree) {
			var radians = (degree - 90) * 2 * Math.PI / 360.0;
			var point = {
				x: centerX + radius * Math.cos(radians),
				y: centerY + radius * Math.sin(radians),
			}
			return point;
		}

		function createCirclePath(centerX, centerY, radius, startDegree, endDegree) {
			var startPoint = calculateCirclePoint(centerX, centerY, radius, endDegree);
			var endPoint = calculateCirclePoint(centerX, centerY, radius, startDegree);
			var largeArcFlag = endDegree - startDegree <= 180 ? 0 : 1;
			var path = 'M ' + startPoint.x + ' ' + startPoint.y + ' A ' + radius + ' ' + radius + ' 0 ' + largeArcFlag + ' 0 ' + endPoint.x + ' ' + endPoint.y;
			return path;
		}

		if ($scope.stepManager.surveyManager.getMode() != "Design") {
			$scope.beginCountdown();
		}
	}
]);